import shouldShowEditButton from '../view/shouldShowEditButton';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import CardItem from 'txp-data/lib/schema/viewSchema/CardItem';
import { editableFlagCustomData } from '../../helpers/EditableCardConsts';

export default function getEditableCustomData(
    txpConfiguration: TxpConfiguration,
    cardItem: CardItem
): any {
    return shouldShowEditButton(txpConfiguration, cardItem) && editableFlagCustomData;
}
